import { capitalize } from 'lodash';
import React from 'react';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { formatCurrencyAmount, getFullDate } from '../../../helpers/formatters';
import { calculatePositionSizeWithPosition } from '../../../helpers/math/position-math.helpers';
import { IPositionResponse } from '../../../services/api/api.interfaces';
import LabelValue from "../../LabelValue/LabelValue";
import NereusButton from '../../NereusButton/NereusButton';
import { TpSlPositionParams } from '../EditPosition/EditPosition';
import ModalWrapper from '../ModalWrapper/ModalWrapper';

import { observer } from 'mobx-react';
import './PositionDetailsModal.scss';

interface PositionDetailsModalProps {
    position: IPositionResponse;
    closePosition?: (positionId: number) => any;
    editPosition?: (position: TpSlPositionParams & IPositionResponse) => any;
}

function getProfitNode(amount?: string | number) {
    amount = Number(amount);
    return amount ? <span className={amount < 0 ? 'nereus-color-status-down' : 'nereus-color-status-up'}>{formatCurrencyAmount(amount, 'USDT', 2)}</span> : null;
}

const PositionDetailsModal: React.FC<PositionDetailsModalProps> = observer(({ position, editPosition, closePosition }) => {

    const openClosePositionModal = () => {
        if (closePosition) {
            closePosition(position.id);
        }
    };

    const openEditPositionModal = () => {
        if (editPosition) {
            editPosition(position);
        }
    };

    return (
        <ModalWrapper className="PositionDetailsModal"
                      headerChildren={<h2
                          className="nereus-body-m">{`${position.baseAsset} ${position.isShort ? 'Short' : 'Long'}`}</h2>}
                      bodyChildren={<div>

                          <LabelValue label="Open Price" value={formatCurrencyAmount(position.initialPrice, '$')}/>
                          {position.lastPrice ?
                              <LabelValue label="Current Price" value={formatCurrencyAmount(position.lastPrice, '$')}/> : null}

                          {position.closedPrice ?
                              <LabelValue label="Closed Price" value={formatCurrencyAmount(position.closedPrice, '$')}/> : null}

                          <LabelValue label={position.isShort ? 'Short' : 'Long'} value={
                              <span
                                  className={position.isShort ? 'nereus-color-status-warning' : 'nereus-color-status-up'}>
                                  {position.leverage}x
                              </span>
                          }/>
                          <LabelValue label="Open Date" value={getFullDate(position.startedAt)}/>
                          {position.finishedAt ? <LabelValue label="Close Date" value={getFullDate(position.finishedAt)}/> : null}
                          <LabelValue label="Status" value={capitalize(position.status)}/>
                          <LabelValue label="Amount"
                                      value={formatCurrencyAmount(calculatePositionSizeWithPosition(position), position.baseAsset)}/>
                          <LabelValue label="Collateral"
                                      value={formatCurrencyAmount(Number(position.amount) / 10 ** tokenDecimals.usdt, 'USDT')}/>
                          <LabelValue label="TP" value={formatCurrencyAmount(position.tpPrice, '$')}/>
                          <LabelValue label="SL" value={formatCurrencyAmount(position.slPrice, '$')}/>

                          {position.feeAmount && Number(position.feeAmount) ?
                              <LabelValue label="Fee" value={<span className="nereus-color-status-down">{formatCurrencyAmount(position.feeAmount, 'USDT', 2)}</span>}/> : null}
                          {position.fee && Number(position.fee) ?
                              <LabelValue label="Fee" value={<span className="nereus-color-status-down">{formatCurrencyAmount(Number(position.fee) / (10 ** tokenDecimals.usdt), 'USDT', 2)}</span>}/> : null}

                          {position.netPnlAmount && position.status !== 'CLOSED' ? <LabelValue label="Net PnL" value={getProfitNode(position.netPnlAmount)}/> : null}
                          {position.realizedPnL && position.status === 'CLOSED' ? <LabelValue label="Net PnL" value={getProfitNode(Number(position.realizedPnL) / 10 ** tokenDecimals.usdt)}/> : null}

                          <div className="PositionDetailsModal__btnRow">
                              {editPosition && <NereusButton color="secondary" onClick={() => openEditPositionModal()} variant="contained">Edit</NereusButton>}
                              {closePosition && <NereusButton color="secondary" variant="contained" onClick={() => openClosePositionModal()}>Close Position</NereusButton>}
                          </div>
                      </div>}/>
    );
});

export default PositionDetailsModal;